import './index.less'
import VisibleComponent from '../VisibleComponent'

const template = `
    <div mtg-el-name="icon" class="mtg-icon-wrap">
         <div class="mtg-icon-box">
            <img src="" alt=""/>
         </div>
    </div>
`

/**
 * Icon类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Icon extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.imgElem = this.element.querySelector('img')
        const {
            url,
            shape,
            size,
            border,
            onClick = () => {
            },
        } = options
        this.imgElem.src = url;

        if (shape === 'circle') {
            this.element.style.borderRadius = "50%"
        }
        if (border) {
            this.element.classList.add("mtg-icon-border")
        }
        switch (size) {
            case "1":
                this.element.classList.add("mtg-icon-size-1")
                break;
            case "2":
                this.element.classList.add("mtg-icon-size-2")
                break;
            case "3":
                this.element.classList.add("mtg-icon-size-3")
                break;
            default:
                this.element.classList.add("mtg-icon-size-3")
        }
        this.element.addEventListener('click', onClick, false)
    }
}

export default Icon